const TAB_ID_KEY = 'gym-tab-id';

export function getTabId() {
  if (typeof window === 'undefined') return 'server';
  let id = window.sessionStorage.getItem(TAB_ID_KEY);
  if (!id) {
    id = typeof crypto !== 'undefined' && crypto.randomUUID
      ? crypto.randomUUID()
      : `tab-${Date.now()}`;
    window.sessionStorage.setItem(TAB_ID_KEY, id);
  }
  return id;
}

export function getAuthStorageKey() {
  const projectRef = process.env.REACT_APP_SUPABASE_URL
    ?.replace('https://', '')
    .split('.')[0];
  return `sb-${projectRef || 'gym'}-auth-${getTabId()}`;
}

export const tabAuthStorage = {
  getItem(key) {
    return window.sessionStorage.getItem(key);
  },
  setItem(key, value) {
    window.sessionStorage.setItem(key, value);
  },
  removeItem(key) {
    window.sessionStorage.removeItem(key);
  },
};

/** Remove old shared localStorage sessions that bleed across tabs */
export function clearLegacyAuthStorage() {
  if (typeof window === 'undefined') return;
  Object.keys(window.localStorage).forEach((key) => {
    if (/^sb-.*auth/i.test(key)) {
      window.localStorage.removeItem(key);
    }
  });
}
